const usdCurrency = 'USD'
const defaultGroup = 'DEFAULT'

export const trackAddShopperConversion = ({ orderId, value, email, currency = usdCurrency }) => {
  if (!window.published) return

  try {
    /* eslint-disable */
    window.AddShoppersWidgetOptions = { loadCss: false, pushResponse: false }
    window.AddShoppersConversion = {
      order_id: `${orderId}`,
      value: `${value}`,
      email: `${email}`,
      currency,
    }

    !function(){
      var t=document.createElement('script')
      t.type='text/javascript',
      t.async=!0,
      t.id='AddShoppers',
      t.src=`https://shop.pe/widget/widget_async.js#${app.ADD_SHOOPERS_ID}`,
      document.getElementsByTagName('head')[0].appendChild(t)
    }()
    /* eslint-enable */
  } catch (e) {
    console.error(e)
  }
}

export const trackAwinConversion = ({
  orderId,
  total,
  tracking,
  promoCode,
  currency = usdCurrency,
}) => {
  const isAwinLoaded = typeof window.AWIN !== 'undefined' && typeof window.AWIN.Tracking !== 'undefined'
  window.AWIN ||= {}
  window.AWIN.Tracking ||= {}
  window.AWIN.Tracking.Sale ||= {}
  const { utmSource, utmMedium, utmCampaign, utmContent, utmTerm } = tracking
  const channelValue = !utmSource || utmSource === 'awin' ? 'aw' : utmSource

  // Conversion pixel
  const merchantId = window.app.awin_merchant_id
  const queryParams = new URLSearchParams({
    tt: 'ns',
    tv: 2,
    merchant: merchantId,
    amount: total,
    cr: currency,
    ref: orderId,
    parts: `${defaultGroup}:${total}`,
    ch: channelValue,
  })
  const img = `<img src="https://www.awin1.com/sread.img?${queryParams.toString()}" border="0" width="0" height="0">`
  // NOTE: it is possible to add cart line item details to tracking - see Awin integration docs
  document.body.insertAdjacentHTML('beforeend', img)

  // Conversion tag
  const customArray = [promoCode, utmMedium, utmCampaign, utmContent, utmTerm]
    .filter((value) => value !== null && value !== undefined ? value : '')
  const sale = window.AWIN.Tracking.Sale
  sale.custom = customArray
  sale.amount = `${total}`
  sale.orderRef = `${orderId}`
  sale.currency = `${currency}`
  sale.parts = `${defaultGroup}:${total}`
  sale.channel = `${channelValue}`
  if (isAwinLoaded) {
    window.AWIN.Tracking.run()
  }
}
